import {
  Workflow,
  Handshake,
  ShieldCheck,
  FileCheck,
  Truck,
  Hammer,
  Settings,
  Headset,
} from "lucide-react";
import "./WhyChooseUs.css";

// ---------------------------------------------------------------------------
// Статистика (левая колонка)
// ---------------------------------------------------------------------------
const STATS = [
  { value: "2009",  label: "работаем на рынке связи и IT" },
  { value: "1",     label: "подрядчик на весь цикл" },
  { value: "УрФО",  label: "Екатеринбург и регионы" },
  { value: "24/7",  label: "сервисная поддержка" },
];

// ---------------------------------------------------------------------------
// Карточки преимуществ (правая колонка)
// ---------------------------------------------------------------------------
const FEATURES = [
  {
    icon: Workflow,
    title: "Полный цикл под одной крышей",
    description:
      "Проект, поставка, строительство сетей связи, настройка активного оборудования, пусконаладка и сервис — всё внутри ООО «АЙТИ СИСТЕМЫ».",
    highlight: true,
  },
  {
    icon: Handshake,
    title: "Один договор и один ответственный",
    description:
      "Никаких «это не наша зона ответственности». Сроки, бюджет и качество — на нас, без переноса вины между смежниками.",
    highlight: true,
  },
  {
    icon: ShieldCheck,
    title: "Опыт на рынке с 2009 года",
    description:
      "Команда выросла из телеком- и провайдерской практики. Понимаем сети не как набор кабелей, а как инфраструктуру, от которой зависит работа бизнеса.",
    highlight: true,
  },
  {
    icon: FileCheck,
    title: "Проектное и строительное СРО",
    description:
      "Полный пакет документации, прохождение экспертизы, допуски для тендеров и госконтрактов.",
    highlight: false,
  },
  {
    icon: Truck,
    title: "Серверное и телеком-оборудование",
    description:
      "Подбираем и поставляем серверы, коммутаторы, маршрутизаторы, Wi-Fi, ИБП, шкафы, камеры и контроллеры под конкретную задачу, а не под складской остаток.",
    highlight: false,
  },
  {
    icon: Hammer,
    title: "Собственные монтажные бригады",
    description:
      "Свои бригады по СКС, ВОЛС, СОТ, СКУД, серверным и слаботочным системам. Контролируем качество монтажа, маркировку и исполнительную документацию.",
    highlight: false,
  },
  {
    icon: Settings,
    title: "Пусконаладка и сдача под ключ",
    description:
      "Настраиваем активное сетевое и серверное оборудование, проверяем каналы, сегменты, доступы, отказоустойчивость и обучаем персонал заказчика.",
    highlight: false,
  },
  {
    icon: Headset,
    title: "Сервис и поддержка 24/7",
    description:
      "После сдачи объект не бросаем. Сервисный контракт по SLA, плановое ТО, аварийный выезд и удалённая диагностика.",
    highlight: false,
  },
];

// ---------------------------------------------------------------------------
// Компонент
// ---------------------------------------------------------------------------
export default function WhyChooseUs() {
  return (
    <section className="why-section">
      <div className="why-container">
        <div className="why-layout">

          {/* ── Левая колонка: заголовок + текст + статистика ── */}
          <div className="why-left">
            <div className="why-left__sticky">

              <div className="why-eyebrow">Преимущества</div>

              <h2 className="why-title">
                Почему<br />
                выбирают{" "}
                <span className="why-title__accent">АЙТИ СИСТЕМЫ</span>
              </h2>

              <p className="why-text">
                Один подрядчик на весь цикл — от обследования и проекта до строительства сетей связи, настройки оборудования и круглосуточного сервиса.
              </p>

              <p className="why-text">
                Работаем из Екатеринбурга по всему УрФО. Основная экспертиза —{" "}
                <span className="why-text__bold">
                  СКС, СОТ, СКУД, серверные и телекоммуникационная инфраструктура
                </span>
                .
              </p>

              {/* Статистика */}
              <div className="why-stats">
                {STATS.map((s) => (
                  <div key={s.value} className="why-stat">
                    <div className="why-stat__value">{s.value}</div>
                    <div className="why-stat__label">{s.label}</div>
                  </div>
                ))}
              </div>

            </div>
          </div>

          {/* ── Правая колонка: сетка карточек ── */}
          <div className="why-right">
            {FEATURES.map((f, idx) => {
              const Icon = f.icon;
              return (
                <div
                  key={idx}
                  className={`why-card${f.highlight ? " why-card--highlight" : ""}`}
                >
                  <Icon
                    className={`why-card__icon${f.highlight ? " why-card__icon--highlight" : ""}`}
                    width={28}
                    height={28}
                  />
                  <h3 className="why-card__title">{f.title}</h3>
                  <p className="why-card__desc">{f.description}</p>
                </div>
              );
            })}
          </div>

        </div>
      </div>
    </section>
  );
}